import { appReducer } from './app/reducer';
import { searchMaskReducer } from './searchMask/reducer';
import { routesReducer } from './routing/reducer';
import { combineReducers } from 'redux';
export var websiteRootReducer = combineReducers({
    app: appReducer,
    searchMask: searchMaskReducer,
    routing: routesReducer
});
export default websiteRootReducer;
